module.exports = __webpack_public_path__ + "img/icon-download.fb753573.svg";